import { useState, useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Col, Row } from 'reactstrap';
import moment from 'moment';
import { Image } from '../../../AbstractElements';
import { fetchPatientDocuments } from '../../../Api/report';
import { dynamicImage } from '../../../Service';
import { getIndividualPatientDoc } from '../../../Api/patient';

interface ShowPatientModalProps {
  isOpen: boolean
  toggle: any
  patient: any
}

const ShowPatientModal = ({ isOpen, toggle, patient }: ShowPatientModalProps) => {
  const [documents, setDocuments] = useState<any[]>([])
  useEffect(() => {
    loadDocuments()
  }, [patient])

  const loadDocuments = async () => {
    try {
      const docs: any[] = await fetchPatientDocuments(patient.id);
      setDocuments(docs);
    } catch (err) {
      console.error("Error loading documents");
    }
  };

  const handleClickDoc = async (documentID: any) => {
    const response: any = await getIndividualPatientDoc(documentID)
    if (response.status !== 200) {
      throw new Error("PDF not found");
    }

    // response.data is the Blob
    const blob = response.data;
    const blobUrl = URL.createObjectURL(blob);

    // Open in new tab
    window.open(blobUrl, "_blank");
  }

  return (
    <div>
      <Modal isOpen={isOpen} toggle={toggle}>
        <ModalHeader toggle={toggle}>Patient Information</ModalHeader>
        <ModalBody style={{ display: 'flex', flexDirection: 'column', gap: '10px', fontSize: '15px' }}>
          <div>
            <div>Patient Name: </div>
            <div style={{ border: '1px solid #dee2e6', padding: '5px 10px', borderRadius: '4px', marginTop: '5px' }}>{patient.firstname} {patient.lastname}</div>
          </div>
          {
            patient.type === 'child' && <div>
              <div>Parent Name: </div>
              <div style={{ border: '1px solid #dee2e6', padding: '5px 10px', borderRadius: '4px', marginTop: '5px' }}>
                {
                  patient?.parent_firstname === null && patient?.parent_lastname === null ? <span style={{ opacity: '0.3' }}>Null</span>
                    : <>{patient.parent_firstname} {patient.parent_lastname}</>
                }
              </div>
            </div>
          }
          <div>
            <div>Email:</div>
            <div style={{ border: '1px solid #dee2e6', padding: '5px 10px', borderRadius: '4px', marginTop: '5px' }}>{patient.email}</div>
          </div>
          <div>
            <div>Gender:</div>
            <div style={{ border: '1px solid #dee2e6', padding: '5px 10px', borderRadius: '4px', marginTop: '5px', textTransform: 'capitalize' }}>{patient.gender || "Prefer not to say"}</div>
          </div>
          <div>
            <div>Address:</div>
            <div style={{ border: '1px solid #dee2e6', padding: '5px 10px', borderRadius: '4px', marginTop: '5px' }}>{patient.address}</div>
          </div>
          <div>
            <div>Phone Number:</div>
            <div style={{ border: '1px solid #dee2e6', padding: '5px 10px', borderRadius: '4px', marginTop: '5px' }}>{patient.phonenumber}</div>
          </div>
          <div>
            <div>Birthday:</div>
            <div style={{ border: '1px solid #dee2e6', padding: '5px 10px', borderRadius: '4px', marginTop: '5px' }}>{moment(patient.birthday).format("YYYY-MM-DD")}</div>
          </div>
          <div style={{ textTransform: 'capitalize' }}>
            <div>Type:</div>
            <div style={{ border: '1px solid #dee2e6', padding: '5px 10px', borderRadius: '4px', marginTop: '5px' }}>{patient.type}</div>
          </div>
          {
            patient.type === 'child' && <div style={{ textTransform: 'capitalize' }}>
              <div>School:</div>
              <div style={{ border: '1px solid #dee2e6', padding: '5px 10px', borderRadius: '4px', marginTop: '5px' }}>{patient?.school}</div>
            </div>
          }
          {
            patient.type === 'child' && <div >
              <div>Teacher Email:</div>
              <div style={{ border: '1px solid #dee2e6', padding: '5px 10px', borderRadius: '4px', marginTop: '5px' }}>
                {
                  patient?.teacher_email ? patient?.teacher_email : <span style={{ opacity: '0.3' }}>Null</span>
                }
              </div>
            </div>
          }
          {
            patient.type === 'child' && <div >
              <div>GP Email:</div>
              <div style={{ border: '1px solid #dee2e6', padding: '5px 10px', borderRadius: '4px', marginTop: '5px' }}>
                {
                  patient?.gp_email ? patient?.gp_email : <span style={{ opacity: '0.3' }}>Null</span>
                }
              </div>
            </div>
          }
          {
            patient.type === 'child' && <div >
              <div>Treating Clinic Email:</div>
              <div style={{ border: '1px solid #dee2e6', padding: '5px 10px', borderRadius: '4px', marginTop: '5px' }}>
                {
                  patient?.treating_clinic_email ? patient?.treating_clinic_email : <span style={{ opacity: '0.3' }}>Null</span>
                }
              </div>
            </div>
          }
          <div>
            <div>Documents</div>
            {
              documents.length > 0 ? <div className="d-flex">
                {
                  documents?.map((document: any, key: any) => {
                    return (
                      <div className="p-2" key={key}>
                        <Image className="img-fluid for-light" src={dynamicImage("logo/PDF.png")} alt="doc" width={100} onClick={() => handleClickDoc(document.id)} />
                        <div className="ps-2" style={{ wordBreak: 'break-word' }}>{document.filename.split("__")[1]}</div>
                      </div>
                    )
                  })
                }
              </div> : <div style={{ marginTop: '5px' }}>There aren't any documents for the patient</div>
            }

          </div>
        </ModalBody>
      </Modal>
    </div>
  )
}

export default ShowPatientModal;